import axios from "services/axios";
import {useMutation, useQueryClient} from "react-query";

import {QUERY} from "./useQueryMedicineUnit";

export function useAddMedicineUnit() {
	const queryClient = useQueryClient();

	return useMutation(formData => axios.post("/medicine/unit/add", formData).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY);
			queryClient.removeQueries(QUERY);
			queryClient.invalidateQueries("medicineUnitOptionsHospital");
			queryClient.removeQueries("medicineUnitOptionsHospital");
		},
	});
}

export function useChangeDataStatus() {
	const queryClient = useQueryClient();

	return useMutation(formData => axios.post("/medicine/unit/change_status", formData).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY);
			queryClient.removeQueries(QUERY);
			queryClient.invalidateQueries("medicineUnitOptionsHospital");
			queryClient.removeQueries("medicineUnitOptionsHospital");
		},
	});
}
